import React, { memo } from 'react'
import StarFilledIcon from 'transfix-icons/build/StarFilledIcon'
import StarIcon from 'transfix-icons/build/StarIcon'
import { Rating as MuiRating, RatingProps as MuiRatingProps } from 'transfix-ui/core'
import { TIconSize } from '../IconWrapper'

export interface IRatingProps
  extends Pick<MuiRatingProps, 'value' | 'onChange' | 'defaultValue' | 'precision'> {
  /**
   * it defines the size of icons to use
   *
   * @default 'medium'
   */
  size: TIconSize
}

export const Rating = memo<IRatingProps>(({ size, ...props }) => {
  return (
    <MuiRating
      {...props}
      icon={<StarFilledIcon color='skyBlue7' size={size} />}
      emptyIcon={<StarIcon color='coolGray4' size={size} />}
      readOnly
    />
  )
})

export default Rating
